import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pdf-disclaimer',
  templateUrl: './pdf-disclaimer.component.html',
  styleUrls: ['./pdf-disclaimer.component.css'],
  standalone: true,
})
export class PdfDisclaimerComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
